import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  computed,
  input,
  linkedSignal,
} from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
  initials: InputSignal<string> = input();
  size: InputSignal<number> = input(40);
  ring: InputSignal<boolean> = input(false);
  border: InputSignal<boolean> = input(false);
  img: InputSignal<string | undefined> = input(undefined);
  /** Imagen genérica para cuando no hay `img` o su carga falla (objeto borrado, 404). */
  fallbackImg: InputSignal<string | undefined> = input(undefined);
  imageClass: InputSignal<string> = input();
  containerClass: InputSignal<string> = input();

  /** Se reinicia sola en cuanto cambia la imagen: la nueva merece su intento. */
  private readonly loadFailed = linkedSignal<string | undefined, boolean>({
    source: this.img,
    computation: () => false,
  });

  /** Imagen que se pinta: la propia, el respaldo genérico o nada (iniciales). */
  readonly src = computed(() => {
    const img = this.img();
    if (img && !this.loadFailed()) return img;

    return this.fallbackImg();
  });

  onImageError() {
    this.loadFailed.set(true);
  }
}
